import LocationCitySearchResourceModel from '../../generated/types/model/resource/LocationCitySearchResourceModel';

export default class LocationCitySearchResourceViewModel extends LocationCitySearchResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
